module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_icon04-a710dff361b0d893ca4b2303e292bc04.png";